export enum ExpenseClassification
{
    None = 'None',
    OpEx = 'OpEx',
    COGS = 'COGS',
}
